module.exports = (__webpack_require__(2))("./core/api/wxApi.js");


//////////////////
// WEBPACK FOOTER
// delegated ./core/api/wxApi.js from dll-reference base
// module id = 91
// module chunks = 22